import { createContext } from 'react';

export const SessionContext = createContext({
  session: null,
  setSession: () => {}
})